function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.45455 12.9091H2V2H18.3636V9.42818",
  stroke: "#A3ABCC",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.0918 12V15.6364C11.0918 17.1427 13.5336 18.3636 16.5463 18.3636C19.5591 18.3636 22.0009 17.1427 22.0009 15.6364V12",
  stroke: "#A3ABCC",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.0918 15.6367V19.2731C11.0918 20.7794 13.5336 22.0004 16.5463 22.0004C19.5591 22.0004 22.0009 20.7794 22.0009 19.2731V15.6367",
  stroke: "#A3ABCC",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M16.5463 14.727C19.5588 14.727 22.0009 13.506 22.0009 11.9997C22.0009 10.4935 19.5588 9.27246 16.5463 9.27246C13.5339 9.27246 11.0918 10.4935 11.0918 11.9997C11.0918 13.506 13.5339 14.727 16.5463 14.727Z",
  stroke: "#A3ABCC",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M10.1825 8.36408C10.6846 8.36408 11.0916 7.95707 11.0916 7.45499C11.0916 6.95291 10.6846 6.5459 10.1825 6.5459C9.68045 6.5459 9.27344 6.95291 9.27344 7.45499C9.27344 7.95707 9.68045 8.36408 10.1825 8.36408Z",
  stroke: "#A3ABCC",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var SvgMoney2 = function SvgMoney2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMoney2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/money2.9f7bf973.svg";
export { ForwardRef as ReactComponent };